const uzc = {
  substantiate: 'Асослаб беринг',
  archive: 'Архив',
  where_to: 'Қаерга',
  year: 'йил',
  salary_cert: 'Олинган даромадлар хақида маълумотнома',
  work_day: 'Иш кунлари',
  holiday: 'Байрам кунлари',
  weekend: 'Дам олиш кунлари',
  dashboard_all: 'Барчаси',
  requiredpdf: 'Фақат pdf файл болсин.',
  requiredsize: 'Файл ҳажми 30 МБ дан кам бўлиши керак!',
  reysters: 'Каталог(Реестр)',
  IT: 'Ахборот технологиялари: ',
  PM: 'Кадрлар бошқаруви: ',
  tabel_acces_denied: "Ушбу табел рақам билан ишлашга рухсатингиз йўқ.",
  signer: 'Имзоловчи',
  acceptable: 'Қабул қилувчи',
  date: 'Имзоланган вақт',
  uzauto: '«UzAuto Motors» АЖ',
  rememberMe: 'Эслаб қолиш',
  itemsPerPageText: '',
  itemsPerPageAllText: 'Ҳаммаси',
  company_id: 'Ташкилот',
  department_id: 'Бўлим',
  cancel: 'Бекор қилиш',
  save: 'Сақлаш',
  logout: 'Тизимдан чиқиш',
  add: 'Қўшиш',
  create: 'Янги яратиш',
  created: 'Яратилган',
  changed: "Ўзгартирилди",
  published: "Эълон килинди",
  contacts: 'Мурожаат учун',
  edit: 'Тахрирлаш',
  delete: 'Ўчириш',
  close: 'Ёпиш',
  select: 'Танланг',
  required: '* билан белгиланган майдонлар мажбурий!',
  input_required: 'Ушбу майдон мажбурий',
  create_update_operation: 'Маълумотлар базасига мувофақиятли сақланди',
  swal_title: 'Ушбу амални бажаришга аминмисиз?',
  swal_text: 'Ушбу амални кейин орқага қайтариб бўлмайди',
  swal_delete: 'Ха, Ўчирилсин!',
  swal_deleted: 'Сизнинг файлингиз ўчирилди!',
  swal_error_title: 'Хўш!',
  swal_error_text: 'Нимадир тўғри бўлмади!',
  name_uz_latin: 'номи ўзбек лотин',
  name_uz_cyril: 'номи ўзбек кирил',
  name_ru: 'номи русча',
  actions: "Амал",
  name: 'Номи',
  description_uz_cyril: 'Изох лотин',
  description_uz_latin: 'Изох лотин',
  description_ru: 'Изох Русча',
  loadingText: 'Юкланмоқда',
  noDataText: 'Маълумот топилмади!',
  created_at: 'Яратилган сана',
  updated_at: 'Тахрирланган сана',
  created_by: 'Яратган фойдаланувчи:',
  updated_by: 'Тахрирлаган фойдаланувчи:',
  deleted_at: 'Ўчирилган сана',
  code: 'Коди',
  filter: 'Фильтр',
  workflow: 'Ҳужжат айланмаси',
  organization: 'Ташкилот',
  balance: 'Баланс',
  created_documents: 'Яратилган ҳужжатлар',
  approved_documents: 'Тасдиқланган ҳужжатлар',
  files: 'Файллар',
  has_employee: 'Ходим бириктиладими',
  start_date: 'йил кунидан',
  end_date: 'йил кунигача',
  all_documents: 'Барча ҳужжатлар',
  uploadFiles: 'Файлларни юклаш',
  publish: 'эълон килиш',
  expectation: 'Кутилмоқда',
  today: 'Бугун',
  yesterday: 'Кеча',
  week: 'Ҳафта',
  oy: 'Ой',
  all: 'Ҳаммаси',
  pending: 'Жараёнда',
  resolution_results: 'Ёналтириш натижалари',
  resolutions: 'Ёналтиришлар',
  executor: 'Ижро учун келган ҳужжатлар',
  expired: 'Муддати тугаётган',
  expired_done: 'Муддати тугаган',
  done: 'Бажарилган',
  ready_templates: 'Тайёр андозалар',
  document_statistics: 'Ҳужжатлар айланмаси статистикаси',
  document_chart: 'Ҳужжатлар айланмаси диаграммада',
  qrCodeTitle: 'Хужжатда кўрсатилган маьлумотларни тўғрилигини текшириш учун QR-кодни мобил телефон орқали сканер қилинг ва корхона маълумотлар сайти орқали текширинг.',
  look: 'Кўриш',
  download: 'Юклаб олиш',
  more_than: 'дан кўп',
  and_less: 'дан кам',
  more_than_s: 'дан кўп символ',
  and_less_s: 'дан кам символ',
  confirm: 'Тасдиқлаш',
  search: 'Қидирув',
  searchInText: 'Текстдан қидириш',
  document_transfer: 'Ҳужжат ўтказиш',
  it_is_impossible: 'Ушбу ҳодимни ишдан олиш ёки бошқа штатга ўтказиб бўлмайди!!!',
  unfinished_documents: 'Тугатилмаган ҳужжатлари мавжуд',
  documents_transferred: 'Ҳужжатларни қуйидаги ҳодимларга ўтказиш мумкин!',
  documents_transferred_employee: 'Ҳужжатларни ҳодимнинг қуйидаги штатларига ўтказиш мумкин!',
  for_info: 'Маълумот учун',
  tags: "Теглар",
  input: {
    required: 'Ушбу майдон мажбурий',
    text: 'Матн киритиш',
  },
  gender: {
    gender: 'Жинси',
    male: 'Эркак',
    female: 'Аёл',
  },
  message: {
    lsp_report: 'ЛСП Хисоботлари',
    lsp_index: 'ЛСП бўйича ҳисоботлар',
    document_template: 'Хужжат шаблонлари',
    document_types: 'Хужжат турлари',
    signers_group: "Имзо қўювчилар гуруҳи",
    positions: 'Штатлар',
    noMessage: "Хабарлар йўқ",
    noAlerts: 'Билдиришномалар йўқ',
    settings: 'Созламалар',
    create: 'Янги хужжат яратиш',
    create: 'Янги хужжат яратиш',
    createInfo: 'Янги маьлумотнома яратиш',
    menu: 'Меню',
    home: 'Асосий сахифа',
    inbox: 'Қабул қилинган хужжатлар',
    draft: 'Қорадамалар',
    inbox: 'Кирувчи ҳужжатлар',
    outbox: 'Чиқувчи ҳужжатлар',
    draft: 'Қоралама ҳужжатлар',
    cancel: 'Бекор қилинган ҳужжатлар',
    sent: 'Юорилган хужжатлар',
    logout: 'Тизимдан чиқиш',
    myCompany: 'Менинг ташкилотим',
    profile: 'Менинг профилим',
    tariffScale: 'Тарифлар кўлами',
    coefficient: 'Устамалар',
    departmentType: 'Бўлимлар турлари',
    personalType: 'Персонал турлари',
    positionType: 'Штат турлари',
    expenceType: 'Харажат турлари',
    requirementType: 'Талаб тури',
    ranges: 'Диапазон',
    countries: 'Давлат',
    regions: 'Вилоят',
    natioanalities: 'Миллат',
    districts: 'Шаҳар/туман',
    requirement: 'Ишга қўйиладиган талаблар',
    documents: 'Ҳужжатлар',
    all: 'Барчаси',
    report: 'Хисобот',
    reports: 'Хисоботлар',
    accessDepartment: 'Ходимлар рухсати',
    accessType: 'Рухсат турлари',
    requisites: 'Реквизитлар',
    currency: 'Валюталар',
    currencyHistory: 'Валюталар тарихи',
    notifications: 'Хабарномалар',
    znz: 'ЗНЗ Хисоботлари',
    znz_index: 'Харид жараёнлари бўйича ҳисоботлар',
    firm_blank: 'Фирма бланка',
  },
  requisites: {
    name_uz_latin: 'Номи ўзбек лотин',
    name_uz_cyril: 'Номи ўзбек кирил',
    name_ru: 'Номи русча',
    name: 'Номи',
    address_name_uz_latin: 'Манзили ўзбек лотин',
    address_name_uz_cyril: 'Манзили ўзбек кирил',
    address_name_ru: 'Манзили русча',
    address: 'Манзили',
    INN: 'ИНН рақами',
    account: 'Ҳисоб рақами',
    swift: 'СВИФТ коди',
    oknh: 'ОКНҲ',
    mfo: 'МФО',
    add_requisites: 'Янги реквизит қўшиш',
    edit: 'Тахрирлаш',
    delete: 'Ўчириш',

  },
  requestdoc: {
    index: 'Маълумотнома сўровчи ташкилотлар',
    new: 'Яратиш',
    update: 'Таҳрирлаш',
    delete: 'Ўчириш',
    unioncom: 'Касаба уюшма қўмитасига',
    bank: 'Банкка',
    tmib: 'ТМИБ га',
    tmig: 'Ташқи миграцияга',
    embassy: 'Элчихонага',
  },
  user: {
    department_name: 'Бўлим номи',
    roles: 'Роллар',
    index: 'Фойдаланувчилар',
    dialogHeaderText: 'Фойдаланувчилар',
    name: 'Исм шарифи',
    email: 'Электрон почтаси',
    phone: 'Телефон рақами',
    department_id: 'Бўлими',
    role_id: 'Роли',
    position: 'Лавозими',
    username: 'Логин',
    newUser: 'Янги фойдаланувчи қўшиш',
    updateUser: 'Тахрирлаш',
    employee: 'Ходим',
    "role-permission": 'Ролларда - рухсатномани бириктириш',
    employee_id: 'Ходим',
    permission: 'Рухсатлар',
    department_code: 'Бўлим коди',
  },
  profile: {
    employee_name: 'Ф.И.Ш',
    user_name: 'Фойдаланувчи номи: ',
    tabel: 'Табел рақами: ',
    born_date: "Туғилган санаси: ",
    department: "Бўлим: ",
    department_code: 'Бўлим коди',
    employee_position: 'Лавозими: ',
    role: 'Роли: ',
    email: 'Электрон почтаси: ',
    imzo: 'Электрон имзо',
    password: 'Парол',
    stir: 'ИНН',
    given_date: 'Берилган сана',
    expere_date: 'Амал қилиш муддати',
    push: 'Танланган имзони профилга бириктириш',
    select_key: 'Калитни танланг',
    incorrect_login: 'Логин ёки парол нотўғри киритилган',
    personal_information: 'Шахсий маълумотлари',
    all_documents: 'Барча ҳужжатлари',
    family_status: 'Оилавий ҳолати',
    information: 'Маълумоти',
    order_date: 'Буйруқ санаси',
    order_number: 'Буйруқ рақами',
    first_work_date: 'Биринчи иш санаси',
    adress: 'Манзил',

  },
  permission: {
    index: 'Рухсатлар',
    name: 'Рухсат номи',
    display_name: 'Куриниш',
    description: 'Изох',
    dialogHeaderText: "Янги рухсат қўшиш",
    edit: 'Тахрирлаш'
  },
  role: {
    index: 'Роллар',
    name: 'Сарлавҳа роли',
    display_name: 'Кўрсатиладиган исм',
    description: 'Эслатма',
    assigned_permissions: 'Бириктирилган рухсатномалар',
    not_assigned_permissions: 'Бириктирилмаган рухсатномалар',
    assigned_roles: 'Бириктирилган роллар',
    not_assigned_roles: 'Бириктирилмаган роллар',
    assign_role: 'Рол бириктириш',
    assign_permission: 'Рухсатнома бириктириш',
    dialogHeaderText: 'Рухсатномаларни ролга тайинланг',
    addRole: 'Янги рол қўшиш',
  },
  department: {
    name: 'Бўлим номи',
    department_type_id: 'Бўлим тури',
    parent_id: 'Асосий бўлим',
    director: "Директор",
    company_id: 'Ташкилот',
    dialog: 'Бўлимлар',
    index: 'Бўлимлар',
    create: 'Янги бўлим яратиш',
    company_name: 'Ташкилот номи',
    department_code: 'Бўлим коди',
    department_name: 'Бўлим номи',
    departments: 'Бўлимлар',
    tree: 'Бўлимлар иерархияси',
    manager_staff: 'Раҳбар штати',
    management: 'Бошқарувчи ходимлар',
    director: "Директор",
    itr: "Инж-тех-ходим",
    restitr: "Инж-тех-ходим Қолганлари",
    rab: "Ишчи",
    master: "Мастер",
    worker: "Ишчи",
    internship: "Амалиётда",
    accountant: "Ҳисобчи",
    brigadir: "Бригадир",
    foreigner: "Хорижликлар",
    maternity: "Декрет",
    women: "Аёллар",
    branch: 'Филиал',
  },
  departments: {
    name: 'Бўлим номи',
    department_type_id: 'Бўлим тури',
    parent_id: 'Асосий бўлим',
    director: "Директор",
    company_id: 'Ташкилот',
    dialog: 'Бўлимлар',
    index: 'Бўлимлар',
    create: 'Янги бўлим яратиш',
    company_name: 'Ташкилот номи',
    department_code: 'Бўлим коди',
    department_name: 'Бўлим номи',
    departments: 'Бўлимлар',
    tree: 'Бўлимлар иерархияси',
    manager_staff: 'Раҳбар штати',

  },
  company: {
    index: 'Ташкилотлар',
    dialogHeaderText: 'Ташкилотлар',
    name: 'Ташкилот номи',
    newOrganization: 'Янги ташкилот',
    updateCompany: 'Ташкилотни тахрирлаш',
  },
  staff: {
    hr: 'Кадрлар бошқаруви',
    name_uz_latin: 'Ўзбек лотин',
    name_uz_cyril: 'Ўзбек кирил',
    name_ru: 'Русча',
    department_id: 'Бўлими',
    position_id: 'Касб                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   ',
    range_id: 'Диапазон',
    personal_type_id: 'Персонал тури',
    expence_type_id: 'Харажат тури',
    rate_count: 'Ставка сони',
    personal_count: 'Персонал саноғи',
    order_date: 'Буйруқ санаси',
    order_number: 'Буйруқ рақами',
    begin_date: 'Бошланиш санаси',
    end_date: 'Тугалланиш санаси',
    editStaff: 'Тахрирлаш',
    newStaff: 'Янги киритиш',
    staff: 'Штатлар жадвали',
    staff_admin: 'Ташкилий бошқарув',
    index: 'Штат жадвали',
    admin: 'Админ панел',
    range_code: 'Разряд',
    expence_type: 'Ҳаражат тури',
    personal_type: 'Персонал тури',
    employees_count: 'Ходим сони',
    branch_id: 'Филиал',
    requirements: 'Кандидат учун талаблар',
    instruction_file_path: 'Йўриқнома файлига хавола',
    uploadFiles: 'Файлни юклаш',
    fileType: 'Файл тури',
    file: 'Файл',
    files: 'Файллар',
    objectType: 'Объект тури',
  },
  documentTypes: {
    list: 'Рўйхат',
    name: 'Номи',
    index: 'Хужжат турлари',
    dialogHeaderText: 'Хужжат турлари'
  },
  document: {
    eimzo_info: 'Рақамли имзо ҳақида маьлумотлар',
    add_parent_document: 'Алоқадор ҳужжатлар',
    children_document: 'Қуйи алоқадор ҳужжатлар',
    add_doer: 'Бажарувчи қўшиш',
    document_sending_department: 'Юборувчи',
    document_number: 'Тартиб рақами',
    letter_number: 'Xat raqami',
    parent_emlpoyee: 'йуналтирувчи ходим',
    create: 'Янги хужжат яратиш',
    new_document: 'Янги хужжат',
    new_document: 'Янги хужжатлар',
    edit_document: 'Тахрирлаш',
    document_type_id: 'Хужжат тури',
    document_created_by: 'Яратган фойдаланувчи:',
    created_at: 'Хужжат яратилган сана:',
    confirmers: 'Хужжатни тасдиқловчилар',
    document_receiving_department: 'Қабул қилувчилар',
    attachments: 'Юклама',
    title: 'Хужжат сарлохаси',
    document_content: 'Хужжатнинг контент қисми',
    short_content: 'Қисқача мазмуни',
    number: "Чиқувчи рақам",
    correspondent: "Корреспондент",
    type: "Тури",
    should_receive_all_departments: 'Барча бўлимларга юбориш',
    documents: 'Ҳужжатлар',
    document_type: 'Ҳужжат тури',
    document_template: 'Ҳужжат шаблонлари',
    document_date: 'Ҳужжат санаси',
    department: 'Бошқарув',
    department_send: 'Юборувчи',
    department_receiver: 'Қабул қилувчи',
    index: 'Ҳужжатлар',
    comment: 'Изоҳлар',
    assignment: 'Топшириқ',
    content: 'Қисқача мазмуни',
    reject: 'Бекор қилиш',
    documentTypes: 'Ҳужжат турлари',
    documentTemplates: 'Андозалар',
    action_type: 'Амал',
    signer_sequence: 'Навбат',
    staff: 'Бўлимлар, лавозимлар',
    signers: 'Имзоловчилар',
    history: 'Ҳужжат тарихи',
    creator: 'Ҳужжат яратувчиси',
    description: 'Ҳужжат тавсифи',
    assignment: 'Топшириқ',
    reaction: 'Амал',
    update: 'Янгилаш',
    resolution: 'Йўналтириш',
    resolution_create: 'Йўналтирилган вақти',
    due_date: 'Муддати',
    files: 'Файллар',
    add_file: 'Файл қўшиш',
    file_name: 'Файл номи',
    full_search: 'Тўлиқ қидирув',
    accept: 'Тасдиқлайман',
    processing: 'Жараёнда',
    vacancy: 'Бўш жой',
    doc_punkts: 'Ҳужжат пунктлари',
    punkt: 'Пункт',
    add_punkt: 'Пункт қўшиш',
    resolution_type: "Йўналтириш тури",
    inboxs: 'Кирувчи ҳужжатлар',
    outboxs: 'Чиқувчи ҳужжатлар',
    drafts: 'Қоралама ҳужжатлар',
    cancels: 'Бекор қилинган',
    inbox: 'Кирувчи',
    outbox: 'Чиқувчи',
    draft: 'Қоралама',
    canceled: 'Бекор қилинган',
    all: 'Барчаси',
    allhr: 'Барчаси',
    alllsp: 'Барчаси',
    allznz: 'Барчаси',
    status: 'Статус',
    term: 'Муддат (соат)',
    add_signer: 'Имзоловчиларни қўшиш',
    document_name: 'Ҳужжат номи',
    add_parent: 'Бевосита раҳбарларни қўшиш',
    empty_employee: 'Ҳодим қўшилмади',
    empty_document_relation: 'Hujjat ilova qilinishi kerak',
    add_employee: 'Ҳодимни қўшинг',
    send: 'юбориш',
    confirmation: 'Тасдиқлаш',
    return_to: 'Ижрога қайтариш',
    copy: 'Ҳужжатдан нусха олиш',
    not_set: 'Ўрнатилмаган',
    start_date: 'Бошланиш санаси',
    end_date: 'Тугаш санаси',
    new: 'Янги',
    doers: 'Ижрочилар',
    doer: 'Ижрочи',
    ok: 'Тасдиқланган',
    cancel: 'Бекор қилиш',
    process: 'Жараёнда',
    reaction_status: 'Имзолаш статуси',
    doers: 'Бажарувчилар',
    doer: 'Бажарувчи',
    pending_action: 'Кутилаётган ҳаракат',
    total_sum: 'Ҳақиқий сумма'
  },
  home: {
    home: 'Асосий',
  },
  tariffScale: {
    index: 'Тариф сеткаси',
    dialogHeaderText: 'Тарифлар',
    category: 'Категорияси',
    salary: 'Маош',
    order_date: 'Буйруқ санаси',
    order_number: 'Буйруқ рақами',
    create: 'Янги тариф сеткаси қўшиш',
    edit: 'Таҳрирлаш'
  },
  coefficient: {
    index: 'Устамалар',
    dialogHeaderText: 'Устамалар',
    code: 'Коди',
    percent: 'Фоиз',
    description: 'Изоҳ',
    order_date: 'Буйруқ санаси',
    order_number: 'Буйруқ рақами',
    status: 'Ҳолат',
    begin_date: 'Бошланиш вақти',
    end_date: 'Тугаш муддати',
    create: 'Янги устама қўшиш',
    edit: 'Таҳрирлаш',
    type: 'Устама тури',
  },
  departmentTypes: {
    index: 'Бўлим турлари',
    dialogHeaderText: 'Бўлим турлари',
    create: 'Янги Бўлим тури киритиш',
    edit: 'Таҳрирлаш'
  },
  personalType: {
    index: 'Персонал турлари',
    dialogHeaderText: 'Персонал турлари',
    create: 'Янги персонал тури киритиш',
    edit: 'Таҳрирлаш'
  },
  positionType: {
    index: 'Касблар турлари',
    dialogHeaderText: 'Касблар турлари',
    code: 'Коди',
    create: 'Янги касб турини киритиш',
    edit: 'Таҳрирлаш'
  },
  position: {
    index: 'Shtatlar',
    updatePosition: 'Тахрирлаш',
    newPosition: 'Янги штат киритиш',
  },
  expenceType: {
    index: 'Харажат турлари',
    dialogHeaderText: 'Харажат турлари',
    create: 'Янги харажат тури қўшиш',
    edit: 'Тахрирлаш',
  },
  ranges: {
    index: 'Диапазонлар',
    dialogHeaderText: 'Диапазон',
    code: 'Коди',
    name: 'Диапазон номи',
    minfond: 'Минфонд',
    maxfond: 'Махфонд',
    order_date: 'Буйруқ санаси',
    order_number: 'Буйруқ рақами',
    create: 'Янги диапазон киритиш',
    edit: 'Таҳрирлаш'
  },
  recruitment: {
    index: 'Ишга ёллаш',
  },
  transfer: {
    index: 'Таржима',
  },
  dismissal: {
    index: 'Ишдан бўшатиш',
  },
  countries: {
    index: 'Давлатлар',
    dialogHeaderText: 'Давлатлар',
    country_code: 'Давлат коди',

  },
  districts: {
    index: 'Шаҳар/туман',
    region_id: 'Вилоят',
    dialogHeaderText: 'Шаҳар/туман'
  },
  regions: {
    index: 'Вилоятлар',
    dialogHeaderText: 'Вилоят',
    country_id: 'Давлат',
    region_id: 'Вилоят',
  },
  natioanalities: {
    index: 'Миллатлар',
    dialogHeaderText: 'Миллатлар',
    name_uz_latin: 'Ўзбекча лотин',
  },
  organization: {
    index: 'Ташкилотлар',
    newOrganization: 'Янги ташкилот қўшиш',
    updateOrganization: 'Таҳрирлаш',
  },
  employeeDocument: {
    index: 'Ходимнинг ҳужжатлари',
    tabel: 'Табел рақами :',
    born_date: "Туғилган санаси :",
    department: "Бўлим :",
    employee_position: 'Лавозими :',
    series: 'Серия',
    number: 'Рақам',
    given_by: 'Ким томонидан берилган',
    date_issue: 'Берилган сана',
    valid_until: 'Aмал қилиш муддати',
    status: 'Статус',
    actions: 'Aмал',
    addEmployeeDocument: "Янги ҳужжатлар қўшиш",
    updateEmployeeDocument: 'Таҳрирлаш',
    docType: 'Ҳужжат тури',
    title: 'Сарлавҳа',
    files: 'Файллар',
    uploadFiles: 'Файлларни юклаш',
    publish: 'эълон килиш',
    expectation: 'Кутилмоқда',
    today: 'Бугун',
    yesterday: 'Кеча',
    week: 'Ҳафта',
    oy: 'Ой',
    all: 'Ҳаммаси',
    pending: 'Жараёнда',
    expired: 'Муддати тугаётган',
    expired_done: 'Муддати тугаган',
    done: 'Бажарилган',
    ready_templates: 'Тайёр андозалар',
    document_statistics: 'Ҳужжатлар айланмаси статистикаси',
    document_chart: 'Ҳужжатлар айланмаси диаграммада',
    qrCodeTitle: 'Хужжатда кўрсатилган маьлумотларни тўғрилигини текшириш учун QR-кодни мобил телефон орқали сканер қилинг ва корхона маълумотлар сайти орқали текширинг.',
  },
  employee: {
    index: 'Ходим',
    deletedIndex: 'Ишдан кетган ходимлар',
    name: 'Ходим',
    Company: 'Ташкилот',
    company_id: 'Ташкилот',
    country_id: 'Давлат',
    Nationality: 'Миллати',
    nationality_id: 'Миллати',
    region_id: 'Вилояти',
    district_id: 'Шаҳар/туман',
    address: 'Манзили',
    tabel: 'Табел рақами',
    firstname_uz_latin: 'Исми лотинча',
    lastname_uz_latin: 'Фамиляси лотинча',
    middlename_uz_latin: 'Отасининг исми лотинча',
    firstname_uz_cyril: 'Исми кирил',
    lastname_uz_cyril: 'Фамиляси кирил',
    middlename_uz_cyril: 'Отасининг исми кирил',
    firstname: 'Исми',
    lastname: 'Фамилияси',
    middlename: 'Отасининг исми',
    born_date: 'Туғилган санаси',
    INN: 'ИНН',
    INPS: 'ИНПС',
    filter: 'Қидирув',
    born_date_from: 'дан (туғилган сана)',
    born_date_to: '(туғилган санаси)',
    department_id: 'Бўлимлар',
    category: 'Категорияси',
    shifr: 'Шифр',
    contract_number: 'Шартнома рақами',
    contract_date: 'Шартнома санаси',
    position: 'Лавозими',
    main_staff: 'Асосий штатда',
    loaded_staff: 'Юклатилган штатда',
    contractDate: 'Меҳ.шарт. санаси',
    contractNumber: 'Меҳ.шарт. Но.',
    enterOrderDate: 'Буйруқ санаси',
    enterOrderNumber: 'Буйруқ рақами',
    coefficients: 'Устамалар',
    all: 'Жами',
    enter_order_date: 'Буйруқ Но',
    enter_order_number: 'Буйруқ санаси',
    percent: 'Миқдори(%)',
    description: 'Изоҳ',
    status: 'Статус',
    begin_date: 'Бошл. санаси',
    end_date: 'Тугаш санаси',
    active: 'Актив',
    inactive: 'Но актив',
    addresses: 'Манзиллар',
    country: 'Республика',
    region: 'Вилоят',
    district: 'Туман',
    street_address: 'Маҳалла',
    street_address_uz_latin: 'Маҳалла лотинчада',
    street_address_uz_cyril: 'Маҳалла кирилчада',
    street_address_ru: 'Маҳалла русчада',
    home_address: 'Уй',
    home_address_uz_latin: 'Лотинчада Уй манзили',
    home_address_uz_cyril: 'Кирилчада Уй манзили',
    home_address_ru: 'Русчада Уй манзили',
    staff_id: 'Штат',
    tariff_scale_id: 'Тариф режаси',
    first_work_date: 'Ишга қабул қилиш санаси',
    leave_order_number: 'Ишдан бўшатиш буйруқ рақами',
    leave_order_date: 'Ишдан бўшатиш тўғрисидаги буйруқ санаси',
    newEmployeeStaff: 'Ишга ёллаш',
    editEmployee: 'Таҳрирлаш',
    is_main_staff: 'Асосий ходимлар',
    employee_staff: "Штатлар",
    range: 'Бўшатиш',
    editEmployeeStaff: 'Ходимлар таркибини таҳрирлаш',
    editemployeeCoefficient: 'Ходимнинг нафақаларини таҳрирлаш',
    editEmployeeAddress: 'Ходимнинг манзилини таҳрирлаш',
    newEmployeeCoefficient: 'Ходимнинг нафақасини яратиш',
    address_type_id: 'Манзил тури',
    order_date: 'Буюртма санаси',
    newEmployeeAddress: 'Ходимнинг манзилини яратиш',
    personalInformation: 'Шахсий маълумотлар',
    education: 'Таълим малака',
    spravka: 'Маълумотномалар',
    family: 'Оилавийлиги',
    work_exprience: 'Иш фаолияти',
    hr: 'Кадр хужжатлари',
    military: 'Харбий ҳисоб',
    taxes: 'Даромад солиғи',
    fullname: 'Ф.И.О.',
    info: 'Ходим',
    new_employee: 'Янги ходим',
    birth_address: "Туғилган манзили",
    residence_address: "Яшаш манзили",
    employee_phones: 'Ходим телефонлари',
    phones: 'Телефонлар',
    phone: 'Телефон',
    phone_type: 'Телефон тури',
    phone_number: 'Телефон рақами',
    add_new_phone: 'Янги телефон қўшиш',
    dismissal: 'Ишдан бўшатиш',
    leave_date: 'Ишдан бўшаш санаси',
    leave_order_date: 'Буйруқ санаси',
    leave_order_number: 'Буйруқ рақами',
    leaving_reason_id: 'Ишдан бўшаш сабаби',
    info: 'Ходим ҳақида маълумот'
  },
  signerGroup: {
    signer_group_id: 'Имзо қўювчилар гуруҳи',
    new_signer_group: 'Имзоловчилар гуруҳини яратинг',
    edit_signer_group: 'Имзоловчилар гуруҳини таҳрирлаш',
    staff_list: 'Ходимлар рўйхати',
    add_signer: 'Имзоловчиларни қўшиш',
  },
  documentTemplates: {
    signers: 'Имзоловчилар штатлари',
    index: 'Ҳужжат шаблонлари',
    sequence: 'Навбат',
    attribute_name_uz_latin: 'Атрибутнинг номи (узб лотин)',
    attribute_name_uz_cyril: 'Атрибутнинг номи (Узбек Кирил)',
    attribute_name_ru: 'Атрибут номи (рус)',
    data_type_id: 'Сана тури',
    value_min_length: 'Мин. қиймати узунлиги',
    value_max_length: 'Макс. қиймати узунлиги',
    description: 'Тавсиф',
    attributeName: 'Атрибут номи',
    due_day_count: 'Муддати',
    sign_type: 'Имзолаш тури',
    registry_type: 'Реестр',

  },
  document_detail_attributes: {
    index: 'Хусусиятлар',
  },
  document_detail_templates: {
    index: 'Тафсилотлар',
    content: 'Таркиб',
    attribute_name_uz_latin: 'Атрибутнинг номи (узб лотин)',
    attribute_name_uz_cyril: 'Атрибутнинг номи (Узбек Кирил)',
    attribute_name_ru: 'Атрибут номи (рус)',
    data_type_id: 'Сана тури',
    value_max_length: 'Мин. қиймати узунлиги',
    value_min_length: 'Макс. қиймати узунлиги',
    description: 'Тавсиф',
    content_uz_latin: "Таркиби ўзбек лотин",
    content_uz_cyril: "Таркиби ўзбек кирил",
    content_ru: "Таркиби русча",
    is_list_vertical: "Вертикал ҳолда кўрсатиладими?",
    is_registry_show: "Реистерда кўрсатиладими?",
    is_show: "Kўрсатиладими?",
  },
  actionTypes: {
    index: 'Фаолият турлари',
    sequence: 'Кетма-кетлик',
  },
  requirementType: {
    index: 'Талаб турлари',
    create: 'Янги қўшиш',
    edit: 'Таҳрирлаш',
    dialogHeaderText: 'Талаб турлари',
  },
  requirement: {
    index: 'Ишга қўйиладиган талаблар',
    type: 'Талаб тури',
    dialogHeaderText: 'Ишга қўйиладиган талаблар',
    requirement_type_id: 'Талаб тури',
    newrequirement: 'Талабларни яратинг',
    updaterequirement: 'Талабларни таҳрирлаш',
  },
  appeal_content: {
    index: 'Шикоят мазмуни',
    create: 'Янги қўшиш',
    edit: 'Таҳрирлаш',
    dialogHeaderText: 'Шикоят мазмуниs'
  },
  object_type: {
    index: 'Обект турлари',
    create: 'Янги обект қўшиш',
    edit: 'Таҳрирлаш',
    dialogHeaderText: 'Янги обект қўшиш'

  },
  purchase_catalogs: {
    catalogs: 'Харид каталоглари',
    add_catalog: 'Харид каталоги қўшиш',
    edit_catalog: 'Харид каталогини таҳрирлаш',
    code: 'Коди',
    part_number: 'Детал рақами',
    description: 'Изоҳ',
    material_content: 'Материал таркиби',
    name_eng: 'Номи инглиз тилида',
    name_ru: 'Номи рус тилида',
    specification: 'Спецификацияси',
    short_name: 'Қисқа номи',
    using_location: 'Жойлашувдан фойдаланиш',
    using_purpose: 'Мақсадли фойдаланиш',
    measure: 'Ўлчов',
    manufacturer: 'Ишлаб чиқарувчи',
  },
  reasons: {
    index: 'Ишдан бўшатилиш сабаблари',
    newReasons: 'Ишдан бўшатилиш сабабларини қўшишъ',
    updateReasons: 'Ишдан бўшатилиш сабабларини таҳрирлаш',

  },
  dismissed: {
    employee: 'Ишдан бўшатилган ходимлар',
  },
  partners: {
    index: 'Ҳамкорлар',
    name: 'Номи',
    adress: 'Манзил',
    bank_name: 'Банк номи',
    bank_adress: 'Банк манзили',
    account: 'Ҳисоб рақами',
    swift_code: 'СWИФТ коди',
    inn: 'ИНН',
    mfo: 'МФО',
    add_partners: 'Янги ҳамкор қўшиш',
    edit: 'Таҳрирлаш'
  },
  report: {
    create_document: "Яратилган ҳужжатлар",
    expired: 'Муддати ўтган',
    prosesing: 'Қайта ишлаш',
    waiting: 'Кутиш',
    completed_on_time: 'Вақтида бажарилган',
    failed_in_time: 'Вақтида бажарилмаган',
  },

  currency: {
    index: 'Валюталар',
    title: 'Валюта турлари',
    name: 'Номи',
    code: 'Коди',
    description: 'Тавсифнома',
    add: 'Янги валюта тури қушиш',
    edit: 'Таҳрирлаш',
    delete: 'Сиз ушбу валюта турини ўчиришга аминмисиз?',
    history: 'Валюталар тарихи',
    price: 'Курс',
    date: 'Сана',
    search: 'Қидирув',
    oper: 'Амаллар',
  },
  notification: {
    index: 'Хабарномалар',
    content: 'Таркиб',
    is_active: 'Холат',
    create: 'Янги хабарнома қўшиш',
    edit: 'Таҳрирлаш',
    delete: 'Сиз ушбу хабарномани ўчиришга аминмисиз?',
  },
  accessDepartment: {
    index: 'Ходимлар рухсати',
    employee: 'Ходимлар рўйхати',
    department: 'Бўлимлар рўйхати',
    access: 'Рухсатлар',
    tabel: 'Табел рақами',
    create: 'Янги рухсат қўшиш',
  },
  accessType: {
    index: 'Рухсат турлари',
    create: 'Янги рухсат тури қўшиш',
    edit: 'Таҳрирлаш',
  },
  registry: {
    index: 'Реестр',
    vacation: "Татил буйруқ реестри",
    business_trip: "Х.сафари буйруқ реестри",
    work_calendar: 'Иш календари',
  },
  carPurchase: {
    ERI: 'Электрон имзо олиш',
    index: 'Aвтомобил сотиб олиш учун ариза',
    view: 'Aвтомобил учун ариза',
    employee: 'Ходим',
    carModel: 'Автомобил модели',
    comment: 'Изоҳ',
    status: 'Холат',
    regStatus: 'Реестр холати',
    accEmployee: 'Хисобчи',
    employeeId: 'Сотрудник',
    file: 'Файл',
    files: 'Файллар',
    create: 'Янги ариза қўшиш',
    createdBy: 'Яратган фойдаланувчи',
    createdAt: 'Сана',
    department: 'Бўлим',
    position: 'Лавозим',
    edit: 'Тахрирлаш',
  },
  company_requisites: {
    name_uz_latin: 'Номи ўзбек лотин',
    name_uz_cyril: 'Номи ўзбек кирил',
    name_ru: 'Номи русча',
    name: 'Номи',
    address_name_uz_latin: 'Манзили ўзбек лотин',
    address_name_uz_cyril: 'Манзили ўзбек кирил',
    address_name_ru: 'Манзили русча',
    address: 'Манзили',
    inn: 'ИНН рақами',
    account: 'РҲисоб рақами',
    swift: 'СВИФТ коди',
    oknh: 'ОКНҲ',
    mfo: 'МФО',
    add_requisites: 'Янги реквизит қўшиш',
    edit: 'Тахрирлаш',
    delete: 'Ўчириш',
  },
  reportDepartment: {
    all: 'Барчаси',
    published: 'Эълон қилинган',
    processing: 'Жараёнда',
    signed: 'Имзоланган',
    ready: 'Тайёр',
    completed: 'Якунланган',
    cancelled: 'Рад эдилган'
  },
  familyRelatives: {
    index: 'Оилавий қариндошлар',
    status: 'Ҳолат',
    add: 'Оилавий қариндошлар қўшиш',

  },
  inventory: {
    index: 'Inventarizatsiya',
    warehouse: 'Ombor',
    comission: 'Komissiya',
    blank_number: 'Blanka raqami',
    part_number: 'Part NO',
    product_name: 'Masxulot nomi',
    real_stock: 'Sanoq',
    address: 'Adres',
    addressName: 'Adres nomi',
    delete: 'Siz ushbu adresni o\'chirishga aminmisiz?',
    product: 'Maxsulotlar ro\'yxati',
    partNumber: 'Detal raqami',
    productName: 'Maxsulot nomi',
    stock: 'Qoldiq',
    unitMeasure: 'O\'lchov birligi',
    report: 'Hisobot',
    commission: 'Komissiya'
  },
  directory: {
    index: 'Журналлар',
    type: 'Журнал турлари',
  }
};

module.exports = uzc
